import { InventoryAdjustmentReasonCreatePage } from '@/features/inventory-adjustment-reason/pages/InventoryAdjustmentReasonCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/inventory-adjustment-reason/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_adjustment_reason.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryAdjustmentReasonCreatePage,
})
